import { RootState } from '@/store';
import { SeoState, SEO_SLICE_NAME } from './models';

export const seoSelector = (state: RootState): SeoState => state[SEO_SLICE_NAME];
